import PrismicRichText from '~/modules/cms/components/prismic/rich-text'
import get from 'lodash/get'
import PrismicImage from '~/modules/cms/components/prismic/prismic-image'

export default {
  components: {
    PrismicImage,
    PrismicRichText,
  },
  props: {
    article: {
      default: () => {},
      type: Object,
    },
  },
  methods: {
    getField (name, defaultValue = [], source) {
      if (typeof source === 'undefined') {
        source = get(this.article, 'data', {})
      }

      return get(source, name, defaultValue)
    },
  },
}
